<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <h1>Школы. Питание</h1>

        <div>
          <v-data-table
            :headers="headers"
            :items="data.results"
            :server-items-length="data.last_page"
            :loading="listLoading.includes(this.fetchDataName)"

            hide-default-footer
            no-results-text="Нет отфильтрованных данных"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.period|period_date }}</td>
                <td>{{ getStatus(item.registry_status).name }}</td>
                <td class="px-0" style="width: 230px;">
                <v-icon
                class="ml-3"
                @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                class="ml-3"
                :loading=true
                @click="downloadRegistryFood(item)"
                >
                  mdi-cloud-download
                </v-icon>
                <v-icon
                class="ml-3"
                :loading=true
                @click="downloadFoodReport(item)"
                v-if="item.registry_status===3"
                >
                  mdi-food
                </v-icon>
                <v-progress-circular
                class="ml-3"
                indeterminate
                color="primary"
                v-if="listLoading.includes('downloadRegistryFood_' + item.id) || listLoading.includes('downloadFoodReport_' + item.id)"
                ></v-progress-circular>
                </td>
              </tr>
              </tbody>
            </template>
            <template slot="no-data">
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="data.last_page"
            ></v-pagination>
          </div>
        </div>

        <router-view></router-view>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      table: 'list-food',
      dialog: false,
      headers: [
        { text: 'Код', align: 'left', sortable: false, value: 'id' },
        { text: 'Период', sortable: false, value: 'period' },
        { text: 'Статус', sortable: false, value: 'registry_status' },
        { text: '', sortable: false }
      ],
      editedItem: {
        id: null,
        period: null,
        registry_status: null
      },
      defaultItem: {
        id: null,
        group: null,
        registry_status: null
      },
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      },
      activeTab: null
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    data () {
      return this.$store.getters['schoolFood/data']
    },
    formTitle () {
      return this.editedItem.id === null ? 'Добавить запись' : 'Редактировать запись'
    },
    fetchDataName () {
      return 'fetchData' + this.table
    },
    user () {
      return this.$store.getters['auth/user']
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },

  // created () {
  //   this.initialize()
  // },

  methods: {
    initialize () {
      this.$store.dispatch('common/clearError')
      this.$store.dispatch('common/pushLoading', this.fetchDataName)

      this.$store.dispatch('schoolFood/fetchData', {
        pageId: this.pagination.page,
        table: this.table
      })
        .then(d => {
          this.$store.commit('schoolFood/setData', d.data)
        })
        .then(() => {
          this.$store.dispatch('common/popLoading', this.fetchDataName)
        })
        .catch(error => {
          this.$store.dispatch('common/setError', error)
          this.$store.dispatch('common/popLoading', this.fetchDataName)
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.$store.commit('schoolFoodListPerson/setData', [])
      this.$router.push({ name: 'schoolFoodListPerson', params: { id: this.editedItem.id } })
      // this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },
    save (preUser, method) {
      if (this.editedItem.id !== null) {
        this.$store.dispatch('common/clearError')
        this.$store.dispatch('common/pushLoading', 'updateData')
        this.$store.dispatch('schoolFood/updateData', { table: this.table, item: this.editedItem })
          .then(d => {
            this.$store.commit('schoolFood/setItem', d.data)
          })
          .then(() => {
            this.$store.dispatch('common/popLoading', 'updateData')
          })
          .catch(error => {
            this.$store.dispatch('common/setError', error)
            this.$store.dispatch('common/popLoading', 'updateData')
          })
      } else {
        // this.desserts.push(this.editedItem)
        this.$store.dispatch('common/clearError')
        this.$store.dispatch('common/pushLoading', 'insertData')
        this.$store.dispatch('schoolFood/insertData', { table: this.table, item: this.editedItem })
          .then(d => {
            this.$store.commit('schoolFood/pushItem', d.data)
          })
          .then(() => {
            // this.initialize()
            this.$store.dispatch('common/popLoading', 'insertData')
          })
          .catch(error => {
            this.$store.dispatch('common/setError', error)
            this.$store.dispatch('common/popLoading', 'insertData')
          })
      }
      this.close()
    },
    getStatus (statusId) {
      return this.$store.getters['schoolFood/status'](statusId)
    },
    downloadRegistryFood (item) {
      const ogrn = this.user.department.ogrn
      const filename = 'food_' + ogrn + '_' + (item.period ? moment(item.period).format('YYYYMM') : '') + '.xlsx'
      this.$store.dispatch('schoolFood/downloadRegistryFood', { id: item.id, filename })
    },
    downloadFoodReport (item) {
      const ogrn = this.user.department.ogrn
      const filename = 'food_report_' + ogrn + '_' + (item.period ? moment(item.period).format('YYYYMM') : '') + '.xlsx'
      this.$store.dispatch('schoolFood/downloadFoodReport', { id: item.id, filename })
    }
  },
  created: function () {
    this.$store.dispatch('schoolFood/fetchStatuses')
    this.initialize()
  }
}
</script>
